import { useQuery } from 'react-query'
import { shallowEqual, useSelector } from 'react-redux'

import type { AssetStats } from '../types'
import { selectSiteIds } from '../../../store/sites'
import { selectUserToken } from '../../../store/user'
import { GateFeedFilter } from '../../../clients/type'
import { assetClient } from '../../../clients/AssetClient'
import { useMemo } from 'react'

type Return = {
  stats: AssetStats[]
  isLoading: boolean
}

type Params = {
  siteId?: string
}

export const useYardStats = ({ siteId }: Params): Return => {
  const siteIds = useSelector(selectSiteIds, shallowEqual)
  const token = useSelector(selectUserToken, shallowEqual)

  const QUERY_KEY = useMemo(() => ['getYardStats', siteId, token], [siteId, token])

  let siteFilter = {}

  if (siteId) {
    siteFilter = {
      type: 'site',
      id: 'site',
      label: 'Site',
      value: { label: 'Initial site', value: siteId },
    }
  }

  const { data: yardStats, isLoading } = useQuery(
    QUERY_KEY,
    () => {
      if (!token) throw new Error('err')
      return assetClient.getYardStats({
        filters: [siteFilter],
        token,
      })
    },
    {
      enabled: !!siteIds,
      refetchOnWindowFocus: false,
      keepPreviousData: false,
    }
  )

  return {
    stats: yardStats?.data || [],
    isLoading,
  }
}
